export default __webpack_public_path__ + "static/media/pngkey.com-linkedin-logo-png-143268.53673384.png";